var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['switch-btn', _vm.switchStatusClass],on:{"click":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }